import getCurrentSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import { mutatorAction } from 'satcheljs';

/** Mutator action to set isLoading value in currently selected table */
export const setIsLoadingForCurrentTable = mutatorAction(
    'setIsLoadingForCurrentTable',
    isLoading => {
        const currentSelectedTableView = getCurrentSelectedTableView();

        if (currentSelectedTableView) {
            currentSelectedTableView.isLoading = isLoading;
        }
    }
);
